import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Play, ArrowRight } from "lucide-react";

const MEDIA_ITEMS = [
  {
    type: "image",
    url: "/gallery-whatsapp-1.jpeg",
    label: "Go-Karting",
    span: "col-span-2 row-span-2",
  },
  {
    type: "video",
    poster: "https://images.unsplash.com/photo-1688391646622-c0d8ac7181a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxtb3RvcnNwb3J0fGVufDB8fHx8MTc3NjE0OTI0Nnww&ixlib=rb-4.1.0",
    src: "/go-kart-track.mp4",
    label: "Track Lap",
    span: "col-span-1 row-span-1",
  },
  {
    type: "video",
    poster: "/speed-rush.mp4",
    src: "/speed-rush.mp4",
    label: "Speed Rush",
    span: "col-span-1 row-span-2",
  },
  {
    type: "image",
    url: "/arcade-zone.jpg",
    label: "Arcade Zone",
    span: "col-span-1 row-span-1",
  },
  {
    type: "image",
    url: "/junior-racers.jpg",
    label: "Junior Racers",
    span: "col-span-1 row-span-2",
  },
  {
    type: "video",
    poster: "/parties.jpg",
    src: "/parties.jpg",
    label: "PARTIES",
    span: "col-span-1 row-span-2",
  },
  {
    type: "image",
    url: "/cafe-party.jpg",
    label: "Rush Hours",
    span: "col-span-1 row-span-2",
  },
  {
    type: "video",
    poster: "/rush-hours.mp4",
    src: "/rush-hours.mp4",
    label: "Race Night",
    span: "col-span-1 row-span-2",
  },
];

function MediaCard({ item, index }) {
  const isVideoWithSrc = item.type === "video" && item.src;
  const imgSrc = item.type === "video" ? item.poster : item.url;

  return (
    <motion.div
      data-testid={`media-item-${index}`}
      className={`relative overflow-hidden group cursor-pointer ${item.span}`}
      style={{ minHeight: item.span.includes("row-span-2") ? "400px" : "200px" }}
      initial={{ opacity: 0, y: 40, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.02 }}
    >
      {isVideoWithSrc ? (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          poster={item.poster}
          src={item.src}
          muted
          loop
          playsInline
          autoPlay
        />
      ) : (
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
          style={{ 
            backgroundImage: imgSrc.includes("unsplash.com")
              ? `url(${imgSrc}&auto=format&fit=crop&q=75&w=800)`
              : imgSrc.includes("pexels.com")
              ? `url(${imgSrc})`
              : `url(${imgSrc})`
          }}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:from-black/90 transition-all duration-500" />

      {/* Label */}
      <div className="absolute bottom-4 left-4 z-10">
        <span className="font-heading text-[#f5f5f5] text-xl sm:text-2xl uppercase opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
          {item.label}
        </span>
      </div>

      {/* Red accent line */}
      <div className="absolute bottom-0 left-0 w-0 group-hover:w-full h-[2px] bg-[#e8001d] transition-all duration-500" />
    </motion.div>
  );
}

export default function MediaGrid() {
  return (
    <section data-testid="media-grid-section" className="py-24 sm:py-32 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          className="mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#e8001d] font-bold mb-4 block">
            Behind The Scenes
          </span>
          <h2 className="font-heading text-[#f5f5f5] text-5xl sm:text-7xl uppercase leading-none">
            Life at the Track
          </h2>
        </motion.div>

        {/* Asymmetric Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 auto-rows-[200px]">
          {MEDIA_ITEMS.map((item, i) => (
            <MediaCard key={i} item={item} index={i} />
          ))}
        </div>

        {/* View More button */}
        <motion.div
          className="text-center mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
        >
          <Link
            to="/gallery"
            data-testid="view-more-gallery-button"
            className="inline-flex items-center gap-3 px-8 py-3 border border-white/20 text-[#f5f5f5] hover:bg-[#e8001d] hover:border-[#e8001d] font-semibold text-sm uppercase tracking-wider transition-all duration-300 group"
          >
            View More
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
